import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../actions";
import strings from "../../helpers/Localization";
import { toast } from "react-toastify";
import { format } from "date-fns";

//CUSTOM ELEMENTS
import Area from "../../aGlobalDesign/Area/Area";
import ButtonSkaRound from "../../aGlobalDesign/Buttons/ButtonSkaRound";
import Modal from "../../aGlobalDesign/Modal/Modal";
import PaginationList from "../../aGlobalDesign/Pagination/PaginationList";
import dayjs from "dayjs";
import DatePicker from "../../aGlobalDesign/DatePicker/DatePicker";
import Avatar from "../../aGlobalDesign/Avatar/Avatar";
import VideoModal from "../../aGlobalDesign/Modal/VideoModal";
import Inputs from "../../aGlobalDesign/Inputs/Inputs";

class VideoMessagesList extends React.Component {

    constructor() {
        super();
        this.state = {
            forcePaginationUpdate: 0,
            saving: false,
            reload: new URLSearchParams(new URL(window.location.href).search).get("reload"),
            zoneList: null,
            callCenterList: null,
            filters: null,
            openMessageModal: null,
            openDialogDateSelector: false,
            openDialogFilter: false,
            dateSelected: {
                // 30 days before today
                "Start date": format(new Date(new Date().setDate(new Date().getDate() - 7)).setHours(0, 0, 0, 0), "yyyy-MM-dd HH:mm:ss").toString(),
                // Today
                "End date": format(new Date(), "yyyy-MM-dd HH:mm:ss").toString()
            }
        };
    }

    componentDidMount() {
        this.props.changeAppBarTitle(strings.Messaging);
        this.props.ChangeCurrentMenuName("Messaging");

        const accessRight = this.props.currentuser.accessrights ? this.props.currentuser.accessrights.hasPermission(600, "consult") : 0;
        this.props.GetRestrictedZones((data) => {

            if (accessRight < 20 || !data.results || data.results.length <= 0) {
                this.setState({ zoneList: [] });
            }
            else {
                const index = data.results.findIndex(i => i.id === this.props.monitoring.calllogszoneId);
                let zone = null;
                if (index && index >= 0 || index === 0) {zone = data.results[index];}
                if (accessRight <= 20) {
                    this.setState({
                        zoneList: data,
                        filters: {
                            zone: zone ? zone : data.results[0],
                            zoneId: zone ? zone.id : data.results[0].id,
                            callCenterList: zone ? zone.secondaryList : data.results[0].secondaryList,
                            callCenter: zone ? zone.secondaryList[0] : data.results[0].secondaryList[0],
                            callCenterId: zone ? zone.secondaryList[0].id : data.results[0].secondaryList[0].id
                        }
                    },
                    () => this.forcePaginationUpdate());
                }
                else {
                    this.setState({
                        zoneList: data,
                        filters: {
                            zone: zone ? zone : null,
                            zoneId: zone ? zone.id : null,
                            callCenterList: zone ? zone.secondaryList : null,
                            callCenter: zone ? zone.secondaryList[0] : null,
                            callCenterId: zone ? zone.secondaryList[0].id : null
                        }
                    },
                    () => this.forcePaginationUpdate());
                }
            }
        }, accessRight
        );
        if (!this.props.monitoring.secondarycallcenters) {
            this.props.GetSecondaryCallCentersList((data) => {});
        }
    }
    forcePaginationUpdate() {
        const temp = this.state.forcePaginationUpdate + 1;
        this.setState({
            tempEditContent: null,
            forcePaginationUpdate: temp
        });
    }
    componentDidUpdate(prevProps) {
        const reload = new URLSearchParams(new URL(window.location.href).search).get("reload");
        if (reload && this.state.reload !== reload) {
            this.setState({ reload: reload });
            this.forcePaginationUpdate();
        }
    }

    //#region functions
    ConvertDateForDisplay() {
        const startDate = this.state.dateSelected["Start date"].substring(0, 10);
        const endDate = this.state.dateSelected["End date"].substring(0, 10);

        // extract party of date
        const startDay = startDate.charAt(8) !== "0" ? startDate.slice(8, 10) : startDate.slice(9, 10);
        const endDay = endDate.charAt(8) !== "0" ? endDate.slice(8, 10) : endDate.slice(9, 10);
        const month = endDate.slice(5, 7);
        const yearstart = startDate.slice(0, 4);
        const yearsend = endDate.slice(0, 4);

        const displayDateSelected = startDay === endDay ?
            startDay + "." + month + "." + yearstart
            :
            startDay + "." + month + "." + yearstart + " ‣ " + endDay + "." + month + "." + yearsend;

        return displayDateSelected;
    }

    saveSelectedFilters() {
        this.forcePaginationUpdate();
        this.setState({ openDialogFilter: false });
    }

    OndeleteContent(Id, onSuccess) {
        this.props.OpenDialog({
            title: strings.confirmDeleteItemVM,
            description: strings.confirmDeleteItemDescVM,
            secondaryLabel: strings.cancel,
            primaryLabel: strings.confirmDelete,
            onPrimaryAction: () => {
                this.props.DeleteVideoMessage(Id, () => {});
                this.forcePaginationUpdate();
            }
        });
    }
    //#endregion

    render() {
        const accessrights = this.props.currentuser && this.props.currentuser.accessrights ? this.props.currentuser.accessrights : {};
        const isSystemAdministrator = this.props.currentuser && this.props.currentuser.user && this.props.currentuser.user.isSystemAdministrator;
        return <>
            <Area
                helmet={strings.Messaging}
                title={strings.Messaging}
                sideButtons={
                    [
                        {
                            type: "secondary-icon",
                            onClick: () => { this.setState({ openDialogDateSelector: true }); },
                            nameIcon: "calendar",
                            text: this.ConvertDateForDisplay()
                        },
                        {
                            type: "secondary-icon",
                            onClick: () => { this.setState({ openDialogFilter: true }); },
                            nameIcon: "filter",
                            disabled: !this.state.zoneList || this.state.zoneList.length <= 0,
                            text: this.state.filters ? this.state.filters.zone && this.state.filters.callCenter ? strings.Filters + "(2)" : this.state.filters.zone || this.state.filters.callCenter ? strings.Filters + "(1)" : strings.Filters + "(0)" : strings.Filters + "(0)"
                        }
                    ]
                }
            >
                <PaginationList
                    forcePaginationUpdate={this.state.forcePaginationUpdate}

                    onGetElements={
                        (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary) => {
                            if (!this.state.filters) {return;}
                            const callCenterId = this.state.filters.callCenterId;
                            const zoneId = this.state.filters.zoneId;
                            const startDate = this.state.dateSelected["Start date"];
                            const endDate = this.state.dateSelected["End date"];
                            this.props.GetVideoMessagesList(pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary, zoneId, callCenterId, startDate, endDate );
                        }
                    }
                    onSavePagination={this.props.SaveVideoMessagesPagination}
                    myElements={this.props.contents.videomessages}

                    sortOptions={[
                        { sortName: "id", sortData: "asc" },
                        { sortName: "datecreated", sortData: "null" },
                        { sortName: "zone", sortData: "null" },
                        { sortName: "callcenter", sortData: "null" },
                        { sortName: "lastmodifiedby", sortData: "null" }
                    ]}

                    tableElement={(element) => {
                        const data = element && element.data ? JSON.parse(element.data) : {};
                        const vmform = element && element.videoMessageForm ? JSON.parse(element.videoMessageForm) : {};
                        return [
                            {
                                colTitle: strings.ID,
                                sortIndex: 1,
                                colContent: element ? "#" + element.videoId : null,
                                fixedWidth: "80px",
                                lockWidth: true
                            },
                            {
                                colTitle: strings.Date,
                                sortIndex: 2,
                                colContent: element && element.dateCreated ? this.props.parseDate(element.dateCreated) : null,
                                fixedWidth: "180px"
                            },
                            {
                                colTitle: strings.client,
                                colContent: vmform && vmform.Name ? vmform.Name : null,
                                fixedWidth: "150px"
                            },
                            {
                                colTitle: strings.company,
                                colContent: vmform && vmform.Company ? vmform.Company : null,
                                fixedWidth: "150px"
                            },
                            {
                                colTitle: strings.CallCenters,
                                sortIndex: 4,
                                colContent: element && element.callCenter ? element.callCenter.name : null,
                                fixedWidth: "150px"
                            },
                            {
                                colTitle: strings.Zone,
                                sortIndex: 3,
                                colContent: element && element.zone ? element.zone.name : null,
                                fixedWidth: "180px"
                            },
                            {
                                colTitle: strings.treatedbyat,
                                fixedWidth: "250px",
                                cellRenderer: ({ tableManager, stringvalue, field, data, column, colIndex, rowIndex }) => {
                                    const value = data[column.field];
                                    if (!value.dateAnswered) {return "";}
                                    return <div style={{ display: "flex", flexWrap: "wrap", gap: "4px", alignItems: "center" }}>
                                        {
                                            value.agentThumbnail ? <Avatar
                                                href={JSON.parse(value.agentThumbnail).PhotoURL}
                                            /> : null
                                        }
                                        {
                                            value.agentName ? <span>{value.agentName}</span> : null
                                        }
                                        {
                                            value.dateAnswered ? <span>{this.props.parseDate(value.dateAnswered)}</span> : null
                                        }
                                    </div>;
                                },
                                colContent: element ? {
                                    agentName: element.agentName,
                                    agentThumbnail: element.agentThumbnail,
                                    dateSeen: element.dateSeen,
                                    dateAnswered: element.dateAnswered
                                } : null
                            },
                            {
                                colTitle: strings.actions,
                                colType: "actions",
                                actions: [1, 2, 3],
                                colContent: [
                                    <ButtonSkaRound
                                        key={"view"}
                                        type={element && element.hasBeenSeen ? "green" : "primary"}
                                        nameIcon="eye"
                                        onClick={() => {
                                            if (!element.hasBeenSeen) {
                                                this.props.ViewVideoMessage(element.id, () => {
                                                    this.forcePaginationUpdate();
                                                });
                                            }
                                            this.setState({ openMessageModal: element });
                                        }}
                                    />,
                                    <ButtonSkaRound
                                        key={"check"}
                                        type={element && element.hasBeenAnswered ? "green" : "primary"}
                                        nameIcon="check"
                                        onClick={() => {
                                            if (!element.hasBeenAnswered) {
                                                this.props.CheckVideoMessage(element.id, () => {
                                                    this.forcePaginationUpdate();
                                                });
                                            }
                                        }}
                                    />,
                                    <ButtonSkaRound
                                        key={"trash"}
                                        type="primary"
                                        nameIcon="trash"
                                        onClick={() => this.OndeleteContent(element.id)}
                                    />
                                ]
                            }
                        ];
                    }}
                />
            </Area>
            <VideoModal open={this.state.openMessageModal !== null}
                onClose={() => this.setState({
                    openMessageModal: null
                })}
                canSave={true}
                validationIcon="upload"
                validationTitle={strings.downloadSource}
                onValidate={() => {
                    const link = document.createElement("a");
                    link.download = "videomessage.webm";
                    link.target = "_blank";
                    link.rel = "noreferrer";
                    link.href = JSON.parse(this.state.openMessageModal.data).Uri;
                    link.click();
                }}
                videosrc={this.state.openMessageModal && this.state.openMessageModal.data ? JSON.parse(this.state.openMessageModal.data).Uri : null}
                thumbnailsrc={this.state.openMessageModal && this.state.openMessageModal.data ? JSON.parse(this.state.openMessageModal.data).ThumbnailUri : null}
            >
                <span style={{ color: "var(--primary-base)", fontSize: "22px", fontWeight: 700 }}>{strings.client}</span>
                <div style={{ display: "flex", width: "100%", flexDirection: "row" }}>
                    <Inputs field={{
                        type: "textfield",
                        allowCopy: true,
                        title: strings.name,
                        disabled: true,
                        value: this.state.openMessageModal ? JSON.parse(this.state.openMessageModal.videoMessageForm).Name : "",
                        onChange: (e) => { }
                    }}/>
                </div>
                <div style={{ display: "flex", width: "100%", flexDirection: "row" }}>
                    <Inputs field={{
                        type: "textfield",
                        allowCopy: true,
                        title: strings.company,
                        disabled: true,
                        value: this.state.openMessageModal ? JSON.parse(this.state.openMessageModal.videoMessageForm).Company : "",
                        onChange: (e) => { }
                    }}/>
                </div>
                <div style={{ display: "flex", width: "100%", flexDirection: "row" }}>
                    <Inputs field={{
                        type: "textfield",
                        allowCopy: true,
                        title: this.state.openMessageModal && JSON.parse(this.state.openMessageModal.videoMessageForm).Contactby === "mail" ? strings.email : strings.phone,
                        disabled: true,
                        value: this.state.openMessageModal ? JSON.parse(this.state.openMessageModal.videoMessageForm).Contact : "",
                        onChange: (e) => { }
                    }}/>
                </div>
                <div style={{ display: "flex", width: "100%", flexDirection: "row", marginTop: "10px" }}>
                    <Inputs field={{ type: "divider" }}/>
                </div>
                <span style={{ color: "var(--primary-base)", fontSize: "22px", fontWeight: 700 }}>{strings.message}</span>
                <div style={{ display: "flex", width: "100%", flexDirection: "row" }}>
                    <Inputs field={{
                        type: "text",
                        title: strings.ID,
                        value: this.state.openMessageModal ? "#" + this.state.openMessageModal.videoId : ""
                    }}/>
                </div>
                <div style={{ display: "flex", width: "100%", flexDirection: "row" }}>
                    <Inputs field={{
                        type: "text",
                        title: strings.Date,
                        value: this.state.openMessageModal ? this.props.parseDate(this.state.openMessageModal.dateCreated) : ""
                    }}/>
                </div>
                <div style={{ display: "flex", width: "100%", flexDirection: "row" }}>
                    <Inputs field={{
                        type: "text",
                        title: strings.CallCenters,
                        value: this.state.openMessageModal && this.state.openMessageModal.callCenter ? this.state.openMessageModal.callCenter.name : ""
                    }}/>
                </div>
            </VideoModal>
            <DatePicker open={this.state.openDialogDateSelector}
                blockFutureDates={true}
                onClose={ () => this.setState({ openDialogDateSelector: false }) }
                onValidate={(range) => {
                    const start = dayjs(range.startDate);
                    const end = dayjs(range.endDate);

                    const normalizedStart = start.startOf("day").format("YYYY-MM-DD HH:mm:ss");
                    const normalizedEnd = end.endOf("day").format("YYYY-MM-DD HH:mm:ss");

                    this.setState({
                        dateSelected: {
                            "Start date": normalizedStart,
                            "End date": normalizedEnd
                        },
                        openDialogDateSelector: false
                    }, this.forcePaginationUpdate );
                }}
            />
            <Modal open={this.state.openDialogFilter}
                onClose={() => {
                    this.setState({ openDialogFilter: false });
                }}
                onValidate={ () => this.saveSelectedFilters() }
                title={strings.Filters}
                icon={"filter"}
                fields={this.state.filters ?
                    [
                        {
                            type: "selectElement",
                            title: strings.Zones,
                            adjustHeight: true,
                            preventEmpty: !this.props.currentuser.accessrights || this.props.currentuser.accessrights.hasPermission(600, "consult") === 20,
                            elementsList: this.state.zoneList,
                            selectedElementId: this.state.filters.zoneId,
                            onSelectElement: (element) => {
                                const temp = this.state.filters;
                                temp.zoneId = element ? element.id : null;
                                temp.zone = element;
                                temp.callCenterList = element ? element.secondaryList : null;
                                temp.callCenterId = null;
                                temp.callCenter = null;
                                this.setState({ filters: temp });
                            }
                        },
                        {
                            type: "selectElement",
                            openTop: true,
                            title: strings.CallCenters,
                            adjustHeight: true,
                            preventEmpty: !this.props.currentuser.accessrights || this.props.currentuser.accessrights.hasPermission(600, "consult") === 20,
                            elementsList: this.state.filters.callCenterList ? { results: this.state.filters.callCenterList } : this.props.monitoring.secondarycallcenters,
                            selectedElementId: this.state.filters.callCenterId,
                            onSelectElement: (element) => {
                                const temp = this.state.filters;
                                temp.callCenterId = element ? element.id : null;
                                temp.callCenter = element;
                                this.setState({ filters: temp });
                            }
                        }
                    ] : null
                }
            />
        </>;

    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default connect(
    (state) => state,
    mapDispatchToProps
)(VideoMessagesList);
